import _ from 'lodash'

import { Thesaurus } from '@skinsoft/types'
import { dbCacheDown } from '../dexie/cache-down';
import { STATS_KEYS } from '../dexie/stats-keys';
import { OfflineDataFetcher } from '@skinsoft/offline'

export class ThesaurusOfflineDataFetcher extends OfflineDataFetcher<Thesaurus>{

    constructor() {
        super(dbCacheDown.thesaurus, STATS_KEYS.thesaurus)
    }

    protected idMatcher(entity: any, id: string) {
        if (entity.thesaurusCS) {
            return entity.thesaurusCS.identifier === id;
        }
        return _.get(entity, 'thesaurusCS.identifier') || false;
    }

}